import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import {
  BRAND_STORAGE_KEY,
  BrandConfig,
  brandConfigs,
  determineBrand
} from 'utils/brandUtils';
import * as sessionStorage from 'utils/sessionStorageUtils';

export type BrandState = {
  brand: string;
  brandConfig: BrandConfig;
};

export const defaultBrandState: BrandState = {
  brand: '',
  brandConfig: brandConfigs.default
};

export const brandSlice = createSlice({
  name: 'brand',
  initialState: defaultBrandState,
  reducers: {
    setBrand: (
      state,
      action: PayloadAction<string | null>,
      storage = sessionStorage
    ) => {
      const providedBrand = action.payload;
      const storedBrand = storage.getItem<string>(BRAND_STORAGE_KEY);

      const determinedBrand = determineBrand(providedBrand ?? storedBrand);

      storage.setItem(BRAND_STORAGE_KEY, determinedBrand);

      state.brand = determinedBrand;
      // If resolvedBrand is not in brandConfigs, set it to default
      state.brandConfig = brandConfigs[determinedBrand] || brandConfigs.default;
    }
  }
});

export const { setBrand } = brandSlice.actions;

export const brandReducer = brandSlice.reducer;

export const brandSelector = (state: RootState) => state.brand;
